import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/CrmCustomer";

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const Create = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const GetById = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const Verify = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:id/Verify`, options);

export const Update = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const Delete = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const UpdateTag = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:id/Tag`, options);

export const UpdateLeadInfo = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:id/LeadInfo`, options);

export const UpdateWorkspace = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:id/Workspace`, options);

export const GetTagTimeline = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:id/TagTimeline`, options);

export const ConvertToCustomer = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:id/ConvertToCustomer`, options);

export const Merge = () => `${PREFIX_URL}/Merge`;

export const GetNotifications = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:id/Notifications`, options);

export const GetNotes = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:id/Note`, options);

export const CreateNote = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:id/Note`, options);

export const UpdateNote = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:id/Note/:noteId`, options);

export const DeleteNote = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:id/Note/:noteId`, options);

export const MatchCustomer = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:id/Customer/:customerId`, options);

export const UnmatchCustomer = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:id/Customer`, options);

export default {
  GetAll,
  Create,
  GetById,
  Verify,
  Update,
  Delete,
  UpdateTag,
  UpdateLeadInfo,
  UpdateWorkspace,
  GetTagTimeline,
  ConvertToCustomer,
  MatchCustomer,
  UnmatchCustomer,
  Merge,
  GetNotifications,
  GetNotes,
  CreateNote,
  UpdateNote,
  DeleteNote,
};
